function SignUpIcon() {
	return (
		<svg
			width="84"
			height="84"
			viewBox="0 0 84 84"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M74.2018 19.5183C79.3835 26.5479 79.7314 35.2204 80.4239 43.9089C81.1498 53.0179 84.2637 63.3283 78.2385 70.1692C72.182 77.0456 61.4924 74.8717 52.3553 75.7776C42.3239 76.772 32.1245 80.4519 23.2514 75.6206C12.2719 69.6423 0.0191374 60.0317 0.553204 47.5718C1.08144 35.2481 16.7259 30.9076 25.5366 22.3069C33.3684 14.6617 37.6212 1.32493 48.5721 0.697417C59.5479 0.0684643 67.6648 10.6499 74.2018 19.5183Z"
				fill="#2EB5DB"
			/>
			<g opacity="0.5">
				<path
					d="M55.6875 58.3242H48.1875"
					stroke="white"
					strokeWidth="2.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M51.9375 62.0747V54.5747"
					stroke="white"
					strokeWidth="2.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<path
				opacity="0.5"
				d="M43.8001 42.1425C43.6126 42.1237 43.3876 42.1237 43.1814 42.1425C38.7189 41.9925 35.1751 38.3362 35.1751 33.8362C35.1564 29.2425 38.8876 25.5112 43.4814 25.5112C48.0751 25.5112 51.8064 29.2425 51.8064 33.8362C51.8064 38.3362 48.2439 41.9925 43.8001 42.1425Z"
				stroke="white"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M43.4814 62.6554C40.0689 62.6554 36.6752 61.7929 34.0877 60.0679C29.5502 57.0304 29.5502 52.0804 34.0877 49.0616C39.2439 45.6116 47.7002 45.6116 52.8564 49.0616"
				stroke="white"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default SignUpIcon;
